module.exports = __webpack_public_path__ + "static/cercazone_nordovest5-5a46514a3e1d71338db7541e7d9cffbc.jpg";